<template>
  <mk-drawer
    class="set-tag-drawer"
    :visible.sync="visible"
    size="890px"
    hide-header
    :before-close="onClose"
  >
    <div class="header">
      <h3>基础设置</h3>
      <i
        class="close el-icon-close"
        @click="onClose"
      ></i>
    </div>
    <div class="form">
      <mk-form
        :model="dialogData"
        label-width="100px"
      >
        <mk-form-item label="标题">
          <mk-input
            v-model="title"
            width="400"
            maxlength="20"
            show-word-limit
          />
        </mk-form-item>
        <mk-form-item label="标签设置">
          <tag-rules
            :key="dialogData.key"
            v-model="dialogData.rules"
            :rules-data="dialogData"
            type="miniMaterial"
          />
        </mk-form-item>
        <!-- <div class="setting-title">
          标签设置
        </div>
        <tag-rules
          :key="dialogData.key"
          v-model="dialogData.rules"
          :rules-data="dialogData"
          :is-scroll="true"
          type="article"
          :is-article="type==='article'"
          :is-all-reprint="isAllReprint"
        /> -->
      </mk-form>
    </div>
    <div class="handle">
      <mk-button-biz @click="onClose">
        取消
      </mk-button-biz>
      <mk-button-biz
        type="primary"
        @click="saveFun"
      >
        确认
      </mk-button-biz>
    </div>
  </mk-drawer>
</template>
<script>
import tagRules from '@components/tag-rules'
export default {
  name: 'SetTagMkawer',
  components: { tagRules },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dialogData: {
      type: Object,
      default () {
        return {}
      }
    },
    // * 当前弹窗的类型：materialArticle(文章)、materialCircleFriends(朋友圈)、form(表单)
    type: {
      type: String,
      default: ''
    },
    // 是否为企业任意转载文章
    isAllReprint: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      title: ''
    }
  },
  computed: {
    typeName () {
      const type = {
        article: '文章',
        case: '案例',
        circleFriends: '朋友圈',
        form: '表单',
        h5: 'H5',
        brochure: '宣传册',
        'video-markting': '营销视频'
      }
      return type[this.type]
    }
  },
  created () {
    this.title = this.dialogData.title
  },
  methods: {
    /**
     * * 弹窗关闭事件
     */
    onClose () {
      this.$emit('update:visible', false)
      this.$emit('on-close')
    },

    /**
     * * 弹窗保存事件
     */
    saveFun () {
      if (this.title === '' || this.title === undefined) {
        this.$message({
          type: 'error',
          message: '请输入标题'
        })
      } else {
        this.$emit('on-confirm', {
          title: this.title
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .set-tag-drawer {
    // /deep/ .tag-select-new {
    //   .tags-box-scroll {
    //     max-height: inherit;
    //     overflow: inherit;
    //   }

    //   .tag-tip {
    //     display: none !important;
    //   }

    //   .px-5.tit {
    //     margin: 10px 0;
    //   }
    // }

    .header {
      line-height: 60px;
      box-shadow: 0 1px 0 0 #e8e8e8;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-shrink: 0;

      h3 {
        font-weight: 500;
        font-size: 16px;
        margin-left: 20px;
      }

      .close {
        font-size: 20px;
        cursor: pointer;
        margin-right: 20px;
        color: #bfbfbf;
      }
    }

    .form {
      height: calc(100vh - 112px);
      overflow-y: auto;

      /deep/ .el-form {
        padding-top: 16px;

        .el-form-item {
          margin-bottom: 12px;
        }
      }
    }

    .handle {
      width: 100%;
      height: 52px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
    }

    .setting-title {
      color: #000;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      margin: 4px 0 10px 30px;
    }

    /deep/ .el-form-item__label {
      font-weight: 500;
      color: #000;
    }

    // /deep/ .tag-select-rules {
    //   width: 820px;
    //   margin-left: 30px;
    // }
  }
</style>
